<template>
  <div class="px-4 py-2">
    <div class="d-flex pt-1">
      <div class="text-left">
        <div class="lable_class">
          Qty
          <span class="sub_value normal_value_color" v-if="item.quantity">{{
            item.quantity
          }}</span>
          <span><v-icon color="#878787">mdi-circle-small</v-icon></span> Avg
          <span class="sub_value normal_value_color">{{ item.averagePrice }}</span>
        </div>
        <div class="symbol_class">{{ item.nseTicker }}</div>
        <div class="lable_class padding_class">
          Capital
          <span class="sub_value normal_value_color">{{ item.currentValue }}</span>
        </div>
      </div>
      <v-spacer></v-spacer>
      <div class="text-right">
        <div
          class="sub_value padding_class"
          :class="item.netChange >= 0 ? 'positive_color' : 'negative_color'"
        >
          <span v-if="item.netChange > 0">+</span>{{ item.netChange }}%
        </div>
        <div
          class="value_class right_box_padding"
          :class="item.PnL >= 0 ? 'positive_color' : 'negative_color'"
        >
          <span v-if="item.PnL > 0">+</span>{{ item.PnL }}
        </div>
        <div class="lable_class padding_class">
          LTP <span class="sub_value normal_value_color">{{ item.LTP }}</span>
          <span
            class="sub_value"
            :class="item.dailyChange >= 0 ? 'positive_color' : 'negative_color'"
            >({{ item.dailyChange }}%)</span
          >
          <!-- <span
            class="sub_value"
            :class="item.netChange >= 0 ? 'positive_color' : 'negative_color'"
            >({{ item.netChange }}%)</span
          > -->
        </div>
      </div>
    </div>
    <!-- <v-divider class="pb-1"></v-divider> -->
  </div>
</template>
<script>
export default {
  name: "RealTradeCard",
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  mounted() {},
};
</script>
<style scoped>
.lable_class {
  color: #878787;

  font-family: Avenir;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.sub_value {
  font-family: Avenir;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.value_class {
  font-family: Avenir;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.normal_value_color {
  color: #434343;
}
.positive_color {
  color: #27ae60;
}
.negative_color {
  color: #eb5757;
}
.padding_class {
  padding-bottom: 5px;
}
.right_box_padding {
  padding-bottom: 3px;
}
.symbol_class {
  color: #000;

  font-family: Avenir;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
</style>
